<template>
  <rabbey-table-3
    :data="dataAp"
    :columns="columns"
    :row-style="{ textAlign: 'center' }"
    :border="true"
    :stripe="true"
    :actions="actions"
    :search="search"
    :loading="loading"
    @rtable-push-action="$emit('rtable-push-action', $event)"
    @update-current-page="$emit('update-current-page', $event)"
    @update-page-size="$emit('update-page-size', $event)"
  />
</template>

<script lang="ts">
import { mapActions, mapMutations /*mapState/*/ } from "vuex";
// import { PAGINATION_DEFAULT } from "@/const";
import COLUMNS from "@/columns/PRM";

export default {
  name: "CustomerTableP",
  props: {
    // items: {
    //   type: Array,
    //   default: () => []
    // },
    dataAp: {
      type: Array,
      default: () => []
    },
    actions: {
      type: Array,
      default: () => []
    },
    search: {
      type: String,
      default: null,
      required: false
    },

    filterList: {
      type: Array,
      default: null,
      required: false
    },

    loading: {
      type: Boolean,
      default: false,
      required: true
    }
    // paginationApi: {
    //   type: Object,
    //   required: false,
    //   default: () => ({
    //     currentPage: 1,
    //     pageSize: 10,
    //     pageSizes: [10, 20, 30, 50, 500],
    //     total: 0
    //   })
    // }
  },
  data() {
    return {
      columns: COLUMNS
      // filter: "",
      // filtered: "",
      // dataAp:[],
      // companyCode: this.$store.state.user.user.CompanySelected
    };
  },
  // created() {
  //   this.setUrl("");
  //   this.setOriginalItems(this.getCustomers);
  //   this.paginate(PAGINATION_DEFAULT);
  // },
  methods: {
    ...mapMutations({
      setOriginalItems: "rabbey_table/originalItems",
      setUrl: "rabbey_table/url"
    }),
    ...mapActions({ paginate: "rabbey_table/paginate" }),
    onPushAction(c) {
      switch (c.command) {
        case "view": {
          this.$refs.details.drawer = true;
          this.data = c.row;
          break;
        }
        default:
          break;
      }
    }
    //   GetProviders() {
    //   this.loading = true;
    //   this.$http
    //     .get(
    //       `/api/Proyects/GetProviders?companyCode=${this.companyCode}`
    //     )
    //     .then((resp) => {
    //       this.dataAp = resp.data;
    //      console.log("klk data: " + this.dataAp);
    //     })
    //     .catch((error) => {
    //       console.error(error);
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // }
  }
  // watch:{
  //   search(valor){
  //         // console.log("klk ",valor);
  //         this.filtered = valor
  //       }
  //     },
  // computed: {
  //   ...mapState({ customers: (state) => state.customers.dbListByCompany }),
  //   getCustomers() {
  //     return this.customers[this.currentCompany];
  //   }
  // }
};
</script>
